var map = {
	"./icon-activity.svg": "4c44",
	"./icon-arrow-ascending.svg": "f9b7",
	"./icon-arrow-descending.svg": "0778",
	"./icon-arrow-left.svg": "f6dc",
	"./icon-arrow-neutral.svg": "412a",
	"./icon-arrow-right.svg": "8139",
	"./icon-book.svg": "c695",
	"./icon-bookmark.svg": "1d5c",
	"./icon-briefcase.svg": "267d",
	"./icon-card.svg": "9eca",
	"./icon-cart.svg": "c8c6",
	"./icon-check.svg": "e179",
	"./icon-chevron-down.svg": "cbb5",
	"./icon-chevron-left.svg": "723e",
	"./icon-chevron-right.svg": "78cc",
	"./icon-chevron-top.svg": "8ff6",
	"./icon-clipboard.svg": "f4c4",
	"./icon-clock.svg": "ccea",
	"./icon-close.svg": "f1ad",
	"./icon-coffee.svg": "6c4c",
	"./icon-credit-card.svg": "b07e",
	"./icon-edit.svg": "6402",
	"./icon-eye-hide.svg": "92e0",
	"./icon-eye-show.svg": "e39f",
	"./icon-flag.svg": "2e1d",
	"./icon-frown.svg": "d4ec",
	"./icon-heart.svg": "86d2",
	"./icon-info.svg": "bd65",
	"./icon-list.svg": "84e0",
	"./icon-logout.svg": "4dea",
	"./icon-meh.svg": "0895",
	"./icon-phone.svg": "a5aa",
	"./icon-pin.svg": "2453",
	"./icon-plus.svg": "d5c0",
	"./icon-save.svg": "9093",
	"./icon-share.svg": "914a",
	"./icon-star.svg": "575a",
	"./icon-thumbs-down.svg": "4726",
	"./icon-thumbs-up.svg": "8287",
	"./icon-tool.svg": "90c4",
	"./icon-trash.svg": "0f16",
	"./icon-truck.svg": "2724",
	"./icon-tv.svg": "1258",
	"./icon-user.svg": "7ec3",
	"./icon-zap.svg": "a15d",
	"./logo-blacheyong-co.svg": "236d",
	"./logo-google.svg": "ec1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";